export default __webpack_public_path__ + "1cc75e2e7485a0ba5c7309c44d355eb8.png";